// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener("DOMContentLoaded", () => {});

// DOM Read for jQuery
// --------------------------------------------------------------- //
jQuery(function ($) {
  console.log("jqueryを使えるぞい");
  $("body").addClass("success");
});

// ハンバーガーメニュー
jQuery(function ($) {
  $(".toggle_btn").click(function () {
    $(this).toggleClass("active");
    $(".site-navigation").toggleClass("active");
  });
});

jQuery(function () {
  //.accordion_oneの中の.accordion_headerがクリックされたら
  jQuery(".archive-list__date").click(function () {
    //クリックされた.accordion_oneの中の.accordion_headerに隣接する.accordion_innerが開いたり閉じたりする。
    jQuery(this).next(".archive-list__items").slideToggle();
    jQuery(this).toggleClass("open");
  });
  jQuery(".wp-block-qa-item__title").click(function () {
    //クリックされた.accordion_oneの中の.accordion_headerに隣接する.accordion_innerが開いたり閉じたりする。
    jQuery(this).next(".wp-block-qa-item__detail").slideToggle();
    jQuery(this).toggleClass("open");
  });
});

// ドット

document.addEventListener("DOMContentLoaded", () => {
  const dotBg = document.getElementById("dotBg");

  const ROW_COUNT = 18;

  for (let i = 0; i < ROW_COUNT; i++) {
    const row = document.createElement("div");

    row.classList.add("dot-row");
    row.classList.add(i % 2 === 0 ? "left" : "right");

    dotBg.appendChild(row);
  }
});

// document.querySelectorAll(".dot-row").length;

// const dotBg = document.getElementById("dotBg");

// function createRows() {
//   dotBg.innerHTML = "";

//   // 1行の理想高さ
//   const idealRowHeight = 80;

//   // サイト全体の高さ
//   const pageHeight = document.body.scrollHeight;
//   document.querySelectorAll(".dot-row").length;

//   // 必要行数
//   const rowCount = Math.ceil(pageHeight / idealRowHeight);

//   // Gridを均等配置
//   // dotBg.style.gridTemplateRows = `repeat(18px, 1fr)`;
//   dotBg.style.gridTemplateRows = `repeat(${rowCount}, 1fr)`;
//   // dotBg.style.gridTemplateRows = `repeat(${rowCount}, 80px)`;

//   // 行生成
//   for (let i = 0; i < rowCount; i++) {
//     const row = document.createElement("div");

//     row.classList.add("dot-row");

//     if (i % 2 === 0) {
//       row.classList.add("left");
//     } else {
//       row.classList.add("right");
//     }

//     dotBg.appendChild(row);
//   }
// }

// createRows();

// window.addEventListener("resize", createRows);

jQuery(function ($) {
  $(".arrow").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500,
    );
  });
});

jQuery(function ($) {
  const video = document.getElementById("loadingVideo");

  video.addEventListener("ended", function () {
    $(".js-loader-bg").fadeOut(800);
  });
});

// window.addEventListener("load", () => {
//   const loading = document.getElementById("loading");

//   setTimeout(() => {
//     loading.classList.add("");

//     setTimeout(() => {
//       loading.remove();
//     }, 500); // CSSのtransition時間と合わせる
//   }, 20000); // 20秒後
// });

// window.addEventListener("load", () => {
//   const video = document.getElementById("loadingVideo");

//   if (!video) return;

//   video.muted = true;
//   video.playsInline = true;

//   const playPromise = video.play();

//   if (playPromise !== undefined) {
//     playPromise.catch((error) => {
//       console.log("Autoplay blocked:", error);
//     });
//   }

//   video.addEventListener("ended", () => {
//     $(".js-loader-bg").fadeOut(800);
//   });
// });

jQuery(function ($) {
  const cursor = document.querySelector(".cursor");

  let mouseX = 0;
  let mouseY = 0;

  let currentX = 0;
  let currentY = 0;

  const speed = 0.1; // 0.05〜0.2くらいがおすすめ

  document.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  function animate() {
    currentX += (mouseX - currentX) * speed;
    currentY += (mouseY - currentY) * speed;

    cursor.style.left = currentX + "px";
    cursor.style.top = currentY + "px";

    requestAnimationFrame(animate);
  }

  animate();
});

jQuery(document).on("mouseenter", "a, button, .toggle_btn", function () {
  jQuery(".cursor").addClass("is-hover");
});

jQuery(document).on("mouseleave", "a, button, .toggle_btn", function () {
  jQuery(".cursor").removeClass("is-hover");
});
